import { Route, Routes } from 'react-router-dom';

import CoursePage from './course-page';
import CoursesPage from './courses-page';
import ExercisePage from './exercise-page';
import LessonPage from './lesson-page';
import SectionPage from './section-page';
import UnitPage from './unit-page';

export default function CoursesRouter() {
    return (
        <Routes>
            <Route
                path="/"
                element={<CoursesPage />}
            />

            <Route
                path="/:courseId"
                element={<CoursePage />}
            />

            <Route
                path="/:courseId/units/:unitId"
                element={<UnitPage />}
            />

            <Route
                path="/:courseId/lessons/:lessonId"
                element={<LessonPage />}
            />

            <Route
                path="/:courseId/sections/:sectionId"
                element={<SectionPage />}
            />

            <Route
                path="/:courseId/exercises/:exerciseId"
                element={<ExercisePage />}
            />
        </Routes>
    );
}